// extracted by mini-css-extract-plugin
export default {"card":"BarchartWidget_card__as3o6","chartArea":"BarchartWidget_chartArea__aqTQS"};